import { render, staticRenderFns } from "./InstalmentOfferLine.vue?vue&type=template&id=44af8036"
import script from "./InstalmentOfferLine.vue?vue&type=script&lang=js"
export * from "./InstalmentOfferLine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PaymentLegalNotices: require('/app/components/PaymentLegalNotices.vue').default})
